import { ListItem, OrderedList, Stack, Text } from '@chakra-ui/react';

import { ReceiptPictogram } from './reimbursement-pictograms';
import { SectionHeading } from './section-heading';

export function ReceiptSection() {
  return (
    <Stack as='section' gap={8}>
      <SectionHeading
        colorScheme='purple'
        pictogram={<ReceiptPictogram />}
        title='Download your receipt'
        singleLineOnMobile
      />
      <Stack color='grey.700' fontSize='16px' fontWeight='400' gap={6} lineHeight='1.5'>
        <Text>
          After you enroll in a Udacity subscription, you will receive a receipt as proof of payment. You will need to
          send this receipt to your employer for reimbursement.
        </Text>
        <OrderedList marginStart={6} spacing={2}>
          <ListItem>
            Go to the “Subscription” tab of your account settings by clicking on the icon in the top right-hand corner
            of your screen when you are logged in.
          </ListItem>
          <ListItem>Scroll to the “Billing History” section.</ListItem>
          <ListItem>
            (Recommended) To add your name to the receipt, click “Add Details” in the “Receipts will be issued to:”
            section. This will show your employer that you were the one who purchased a subscription.
          </ListItem>
          <ListItem>Click the receipt icon in the billing history table to download the receipt.</ListItem>
        </OrderedList>
      </Stack>
    </Stack>
  );
}
